import React, { useState } from 'react'

import { bemJoin } from 'bem-join'

import { ReactComponent as EyeIcon } from '@app/assets/Small/Outline/Eye.svg'
import { DATE_TIME_FORMAT, formatDateTime } from '@app/common/helpers/DateTime/DateTime'
import { CourtCasePaymentEvent } from '@app/graphql/types'
import { useIntl } from '@app/intl/Intl'
import { IconButton } from '@app/lib/inputs/IconButton/IconButton'
import { useCourtCaseContext } from '@app/modules/CourtCases/Components/CourtCaseContext/CourtCaseContext'

import './styles.scss'

interface CourtCaseInvoiceItemProps {
  paymentEvent: Partial<CourtCasePaymentEvent>
}

export const CourtCaseInvoiceItem: React.FC<CourtCaseInvoiceItemProps> = ({ paymentEvent }) => {
  const b = bemJoin('court-case-invoice-item')
  const { formatMessage } = useIntl()
  const [isExpanded, setIsExpanded] = useState(false)

  const renderValue = (value: any): string => {
    if (value === null) return 'null'
    if (value === undefined) return 'undefined'
    if (typeof value === 'object') return JSON.stringify(value)
    return String(value)
  }

  const { data: courtCaseData, loading, error } = useCourtCaseContext()
  const initatorName =
    paymentEvent.initiatorRole == 'ADMIN'
      ? 'Administrator'
      : !loading && !error
      ? `${courtCaseData?.assignedLawyer?.firstName} ${courtCaseData?.assignedLawyer?.lastName}`
      : ''

  return (
    <div className={b()}>
      <div className={b('main')}>
        <div className={b('date-info')}>
          {formatDateTime(paymentEvent.createdAt, DATE_TIME_FORMAT.DATE_TIME_PAST)}, {initatorName}
        </div>
        <div className={b('status')}>
          {formatMessage({ id: 'CourtCases.Invoicing.Section.Invoices.List.Item.Status.Sent' })}
        </div>
        <div className={b('actions')}>
          <IconButton
            size='sm'
            aria-label='see_details'
            variant='outlined'
            shape='rectangle'
            color='secondary'
            onClick={() => {
              setIsExpanded((prev) => !prev)
            }}
          >
            <EyeIcon />
          </IconButton>
        </div>
      </div>
      {isExpanded && (
        <div className={b('payload')}>
          {Object.entries(paymentEvent.payload).map(([key, value]) => (
            <div key={key}>
              <strong>{key}</strong>: {renderValue(value)}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
